var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth__block"},[_c('h1',{staticClass:"title-h2 auth__title"},[_c('i18n',{attrs:{"path":"main.sign_in_to_account"}},[_c('br')])],1),_c('div',{staticClass:"auth__fields-wrapper"},[_c('EuKey')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }